@use '@/styles/tokens' as *;

.vertical {
  display: flex;
  flex-direction: column;
  gap: $space-2;
}

.horizontal {
  display: flex;
  flex-direction: row;
  gap: $space-4;
}
